import { jssdkTypes } from '@ebscn/jssdk/types/jssdk';
import { useEffect, useState } from 'react';
import Body from '../components/Body';
import type { NextPage } from 'next';
import { Toast } from 'antd-mobile';
import styles from './head.module.scss';

let jssdk: jssdkTypes;
const initAsyncComponents = async () => {
    //浏览器渲染时需要执行的方法
    jssdk = await import('@ebscn/jssdk');
};

const Home: NextPage = () => {
    const [appVersion, setAppVersion] = useState('');
    let openDownload: any;
    const hasApp = false;
    async function init() {
        (window as any).document.title = '光大证券';
        await initAsyncComponents();
        setAppVersion((window as any).ACTIVE_CONF.download.jygAppVersion);
    }
    useEffect(() => {
        init();
        downLoad();
    }, []);

    useEffect(() => {
        if (isIphonex()) {
            const btn = document.getElementById('app_btn');
            btn!.style.bottom = '15px';
            const btn_bottom = document.getElementById('app_btn_bottom');
            btn_bottom!.style.display = 'block';
        } else {
            const btn = document.getElementById('app_btn');
            btn!.style.bottom = '0px';
        }
    });

    const isIphonex = () => {
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
    };

    function is_weixin() {
        const ua: any = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    }

    function loadHtml(ios: boolean) {
        const div = document.getElementById('weixin-tip') as HTMLElement;
        div.style.display = 'block';
        if (ios) {
            const pi = document.getElementById('ios') as HTMLElement;
            pi.style.display = 'block';
            const pa = document.getElementById('android') as HTMLElement;
            pa.style.display = 'none';
        }
    }

    // function loadAndroidToast(android:boolean) {
    //     if (android) {
    //         const androidToast = document.getElementById('android-tip') as HTMLElement;
    //         androidToast.style.display = 'block';
    //         setTimeout(()=> {
    //             const androidToast = document.getElementById('android-tip') as HTMLElement;
    //             androidToast.style.display = 'none';
    //         },2000)
    //     }
    // }

    function getQueryString(name: string) {
        const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        const r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return '';
    }
    function listener() {
        //有过切换操作，不代表安装或者未安装，但是消除一切参数置换的副作用
        // hasApp = true;
        document.removeEventListener('visibilitychange', listener);
        //add by jinyuanche 只要在返回的时候终止自动跳转逻辑可能带来的负影响，就可以确保无问题。
        if (openDownload) {
            clearTimeout(openDownload);
        }
        // setTimeout(() => {
        //     // eventloop 重置hasApp
        //     hasApp = false;
        // }, 0);
    }

    function downLoad() {
        const u = navigator.userAgent;
        const versions = {
            //移动终端浏览器版本信息
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        };

        if (is_weixin()) {
            if (versions.ios || versions.iPhone || versions.iPad) {
                loadHtml(true);
            } else {
                loadHtml(false);
            }
        } else {
            document.addEventListener('visibilitychange', listener);
            if (openDownload) {
                clearTimeout(openDownload);
            }
            if (versions.ios || versions.iPhone || versions.iPad) {
                window.location.href = (window as any).ACTIVE_CONF.oDownload.iosItunesUrl;
            } else if (versions.android) {
                // loadAndroidToast(true)
                window.location.href = (window as any).COMMON_CONF.opDownloadUrl;
            }
        }
    }

    return (
        <>
            <Body>
                <div className={styles.container}>
                    {/* 底部按钮 */}
                    <div className={styles['app_btn']} id="app_btn" onClick={downLoad}></div>
                    {/* 底部安全域填充盒子 */}
                    <div className={styles['app_btn_bottom']} id="app_btn_bottom" style={{ display: 'none' }}></div>
                    {/* 右上角分享弹框提示 */}
                    <div id="weixin-tip" className={styles['weixin-tip']} style={{ display: 'none' }}>
                        <p id="android">
                            <img src="/active/images/download/live_weixin_android.png" />
                        </p>
                        <p id="ios" style={{ display: 'none' }}>
                            <img src="/active/images/download/live_weixin_ios.png" />
                        </p>
                    </div>
                    {/* 安卓端提示框 */}
                    {/* <div id="android-tip" className={styles['android-tip']} style={{ display: 'none' }}>
                        <p>暂不支持安卓端下载,敬请期待</p>
                    </div> */}
                </div>
            </Body>
        </>
    );
};
export default Home;
